import { render, staticRenderFns } from "./CaptureProfiles.vue?vue&type=template&id=e2d938de&scoped=true&"
import script from "./CaptureProfiles.vue?vue&type=script&lang=js&"
export * from "./CaptureProfiles.vue?vue&type=script&lang=js&"
import style0 from "./CaptureProfiles.vue?vue&type=style&index=0&id=e2d938de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d938de",
  null
  
)

export default component.exports